
// src/App.js
import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import LoginPage from './pages/LoginPage';
import App2 from './pages/App2';
import { ProgressProvider } from './context/ProgressContext';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import PrivateRoute from './components/PrivateRoute';
import './App.css';
function App() {
  return (
    <AuthProvider>
      <UserProvider>
        <ProgressProvider>
          <Router>
            <AnimatePresence mode="wait">
              <Routes>
                {/* Public Route */}
                <Route path="/" element={<LoginPage />} />
                {/* Protected Routes */}
                <Route
                  path="/App2"
                  element={
                    // <PrivateRoute>
                      <App2 />
                    // </PrivateRoute>
                  }
                >
                </Route>
              </Routes>
            </AnimatePresence>
          </Router>
        </ProgressProvider>
      </UserProvider>
    </AuthProvider>
  );
}
export default App;

